module.exports = __webpack_public_path__ + "static/images/components/ChallengeContent/components/Label/images/label.d31bdcaa.png";


//////////////////
// WEBPACK FOOTER
// ./components/ChallengeContent/components/Label/images/label.png
// module id = 2589
// module chunks = 11